import styled from 'styled-components';
import {dFlexCenter, mobileMedia} from '../../../globalVariables/GlobalVariables';
import {btn} from '../../../component/button/btn/Btn.css';
import {dFlexColumnCenter} from '../../../globalVariables/GlobalFlex';
import {getSpacing} from '@tickchak/react-share/app';

export const wrapper = styled.div`
    ${dFlexCenter};
    gap: ${getSpacing('spaceSm')};

    ${mobileMedia} {
        ${dFlexColumnCenter};
        ${btn} {
            width: 170px;
        }
    }
`;

